import { InAppCredits } from "../../types/mailcredit";
import { LovewallSubscription } from "../../types/subscription";
import { Wedding } from "../../types/wedding";
import { generateAPI } from "../api.generator";

export const getEventPlannerWeddingsWithCreditsAndSubscriptions = generateAPI<
  {},
  (Wedding & {
    inAppCredits: InAppCredits;
    lovewallSubscription?: LovewallSubscription;
  })[]
>("get", "package-bundle/weddings");
